import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'; // Homepage (keep direct)
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import CustomLoader from './components/loading';

// Lazy-loaded components
const Signup = lazy(() => import('./signup'));
const Login = lazy(() => import('./login'));
const Second = lazy(() => import('./second'));
const Exercise = lazy(() => import('./exercise'));
const ExerciseLogs = lazy(() => import('./exerciselogs'));
const EditExercisePage = lazy(() => import('./edit-exercise'));
const StartExercise = lazy(() => import('./start-exercise'));
const SplitsPage = lazy(() => import('./splits'));

const BMIPage = lazy(() => import('./calculators/bmi'));
const BMRPage = lazy(() => import('./calculators/bmr'));
const CaloriesPage = lazy(() => import('./calculators/calories'));
const BodyFatPage = lazy(() => import('./calculators/bodyfat'));
const LeanMassPage = lazy(() => import('./calculators/leanmass'));
const IdealWeightPage = lazy(() => import('./calculators/idealweight'));
const TDEEPage = lazy(() => import('./calculators/tdee'));
const OneRepMaxPage = lazy(() => import('./calculators/onerepmax'));
const MacroSplitPage = lazy(() => import('./calculators/macrosplit'));
const WaterIntakePage = lazy(() => import('./calculators/waterintake'));
const BodyRecompositionPage = lazy(() => import('./calculators/bodyrecomposition'));

const BlogsPage = lazy(() => import('./blogs-page'));
const St1 = lazy(() => import('./blogs/st1'));
const St2 = lazy(() => import('./blogs/st2'));
const St3 = lazy(() => import('./blogs/st3'));
const St4 = lazy(() => import('./blogs/st4'));
const St5 = lazy(() => import('./blogs/st5'));
const Dn1 = lazy(() => import('./blogs/dn1'));
const Dn2 = lazy(() => import('./blogs/dn2'));
const Dn3 = lazy(() => import('./blogs/dn3'));
const Dn4 = lazy(() => import('./blogs/dn4'));
const Dn5 = lazy(() => import('./blogs/dn5'));

const root = ReactDOM.createRoot(document.getElementById('root'));

const PrivateRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

root.render(
  <BrowserRouter>
    <Suspense fallback={<CustomLoader />}>
      <Routes>
        <Route path="/" element={<App />} />
        {/* Auth */}
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />

          {/* Calculators */}
          <Route path="/calculators/bmi" element={<BMIPage />} />
          <Route path="/calculators/bmr" element={<BMRPage />} />
          <Route path="/calculators/calories" element={<CaloriesPage />} />
          <Route path="/calculators/tdee" element={<TDEEPage />} />
          <Route path="/calculators/bodyfat" element={<BodyFatPage />} />
          <Route path="/calculators/leanmass" element={<LeanMassPage />} />
          <Route path="/calculators/idealweight" element={<IdealWeightPage />} />
          <Route path="/calculators/one-rep-max" element={<OneRepMaxPage />} />
          <Route path="/calculators/macro-split" element={<MacroSplitPage />} />
          <Route path="/calculators/water-intake" element={<WaterIntakePage />} />
          <Route path="/calculators/body-recomposition" element={<BodyRecompositionPage />} />

          {/* FitGenie and Exercises */}
          <Route path="/fit-g" element={<Second />} />
          <Route path="/exerciselogs" element={<ExerciseLogs />} />
          <Route path="/splits" element={<SplitsPage />} />
          <Route path="/split" element={<SplitsPage />} />
          <Route path="/workouts" element={<SplitsPage />} />
          <Route path="/edit-exercise" element={<EditExercisePage />} />
          <Route path="/create-workout" element={<EditExercisePage isCreateMode={true} />} />
          <Route path="/start-exercise" element={<PrivateRoute><StartExercise /></PrivateRoute>} />
          <Route path="/exercise" element={<Exercise />} />
          <Route path="/exercise/" element={<Exercise />} />

          {/* Blogs */}
          <Route path="/blogs" element={<BlogsPage />} />
          <Route path="/blogs/what-is-hiit-and-why-is-it-effective" element={<St1 />} />
          <Route path="/blogs/how-to-start-a-hiit-workout-as-a-beginner" element={<St2 />} />
          <Route path="/blogs/how-often-should-you-do-hiit-workouts-per-week" element={<St3 />} />
          <Route path="/blogs/hiit-vs-steady-state-cardio" element={<St4 />} />
          <Route path="/blogs/common-hiit-injuries-and-prevention" element={<St5 />} />
          <Route path="/blogs/what-are-macronutrients-and-why-they-matter" element={<Dn1 />} />
          <Route path="/blogs/roles-proteins-carbs-fats-body" element={<Dn2 />} />
          <Route path="/blogs/essential-vitamins-minerals-for-active-people" element={<Dn3 />} />
          <Route path="/blogs/how-to-read-nutrition-labels" element={<Dn4 />} />
          <Route path="/blogs/common-nutrient-deficiencies" element={<Dn5 />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
);

reportWebVitals();
